"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var useForceUpdate = function useForceUpdate() {
  var _ref = (0, _react.useState)(0),
      _ref2 = _slicedToArray(_ref, 2),
      value = _ref2[0],
      setValue = _ref2[1]; // integer state


  return function () {
    return setValue(function (value) {
      return value + 1;
    });
  }; // update the state to force render
};

var _default = useForceUpdate;
exports.default = _default;